import Header from './Header'
import Card from './Card'
import Corkboard from './Corkboard'
import MissionCard from './MissionCard'
import Chalkboard from './Chalkboard'
import EmailCard from './EmailCard'
import Interactive from './Interactive'

import InteractivesArea from './InteractivesArea'
import Nelson from './Nelson'
import { useState, useEffect } from 'react'

const Healthcare = ({ onScreenUpdate }) => {
  const [dialogue, setDialogue] = useState(null)
  const [showDialogue, setShowDialogue] = useState(false)
  const [learnLink, setLearnLink] = useState(null)
  const dialogueLinkText = 'Learn More'

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="mainContainer">
      <audio id="gulping" src="audio/health/gulping.mp3" />
      <audio id="teeth" src="audio/health/false_teeth.mp3" />
      <audio id="hotdog" src="audio/health/hotDog.mp3" />

      <Header onScreenUpdate={onScreenUpdate} />
      <div className="chalkAndIconsAndCork">
        <div className="chalkAndIcons">
          <Chalkboard>
            <div className="chalkboardHeader LithosPro healthcareHeader">
              Healthcare &amp; Nutrition
            </div>
            <div className="chalkboardContent">
              <p>
                Feeding horses is fun. It's one of the quickest ways to make an
                apple disappear! There's a real science to it - nutritional
                needs change if a horse is old or young, a racer, or a grazer.
              </p>
              <p>
                Click around and learn how to keep an athletic horse fast and
                happy, how to keep an older horse chewing, and why you should
                never eat a hot dog near Lord Nelson!
              </p>
            </div>
          </Chalkboard>
          <InteractivesArea>
            <Interactive
              cat={'healthcare'}
              itemName={'sports drink'}
              alt={'a red sports drink'}
              url={'feedingAthletes.html'}
              sound={'gulping'}
              onClick={(speaking) => {
                setShowDialogue(speaking)
                setDialogue(
                  <div>
                    <p>
                      As super athletes, horses need help when it comes to
                      nutritional science.
                    </p>
                    <p>
                      On a training day, a race horse might slurp enough water
                      to fill 160 of those sports bottles that humans use!
                    </p>
                  </div>
                )
                setLearnLink('pages/healthcare/feedingAthletes.html')
              }}
            />
            <Interactive
              cat={'healthcare'}
              itemName={'dentures'}
              alt={'dentures floating in a glass of water'}
              url={'feedingOlderHorses.html'}
              sound={'teeth'}
              onClick={(speaking) => {
                setShowDialogue(speaking)
                setDialogue(
                  <div>
                    <p>Hay soup!?! Lose a tooth and it can be hard to chew.</p>
                    <p>
                      Stop exercising and we can gain weight and lose body
                      condition, which makes us prone to health problems.
                    </p>
                    <p>
                      I'm glad scientists figured out how to feed older horses.
                    </p>
                  </div>
                )
                setLearnLink('pages/healthcare/feedingOlderHorses.html')
              }}
            />
            <Interactive
              cat={'healthcare'}
              itemName={'hotdog'}
              alt={'a hotdog with relish and mustard in a hotdog bun'}
              url={'feedingYourHorse.html#hotdog'}
              sound={'hotdog'}
              onClick={(speaking) => {
                setShowDialogue(speaking)
                setDialogue(
                  <div>
                    <p>
                      You'd be surprised at the crazy things horses like. I'm
                      glad the Equine Science Center researchs what's good and
                      bad for us.
                    </p>
                    <p>
                      A few gummy bears are fine, and I love peppermints! But a
                      tomato plant? Never!
                    </p>
                  </div>
                )
                setLearnLink('pages/healthcare/feedingYourHorse.html')
              }}
            />
          </InteractivesArea>
        </div>
        <Corkboard onScreenUpdate={onScreenUpdate}>
          <MissionCard />
          <EmailCard />

          <Card className="linksCard">
            <div className="cardTitle linksTitle">Links</div>

            <div className="linksLink">
              <a
                href="pages/healthcare/healthFAQ.html"
                target="_blank"
                rel="noreferrer"
              >
                Healthcare FAQs
              </a>
            </div>
            <div className="linksLink">
              <a
                href="pages/healthcare/feedingYourHorse.html"
                target="_blank"
                rel="noreferrer"
              >
                Horse Food
              </a>
            </div>
            <div className="linksLink">
              <a
                href="pages/healthcare/feedingOlderHorses.html"
                target="_blank"
                rel="noreferrer"
              >
                Feeding Older Horses
              </a>
            </div>
            <div className="linksLink">
              <a
                href="pages/healthcare/feedingAthletes.html"
                target="_blank"
                rel="noreferrer"
              >
                Feeding Four-Legged Athletes
              </a>
            </div>
          </Card>
        </Corkboard>
      </div>
      <Nelson
        showDialogue={showDialogue}
        dialogue={dialogue}
        setShowDialogue={setShowDialogue}
        learnLink={learnLink}
        dialogueLinkText={dialogueLinkText}
      />
    </div>
  )
}

export default Healthcare
